import Expander from 'components/utils/Expander'
import NavBarContactsItems from 'components/NavKit/NavBarButtons/NavBarContactsItems'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import Group from 'components/utils/Group'
import GeoContext from 'contexts/geoContext'
import useToggle from 'hooks/useToggle'
import shouldRenderTimely from 'lib/timely/timely'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import LineAngleUpIcon from 'LuxKit/Icons/line/LineAngleUpIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import { useContext } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  onItemClick: () => void
}

function NavBarHamburgerMenuContactsAccordion(props: Props) {
  const { onItemClick } = props
  const intl = useIntl()
  const [expanded, toggleExpanded] = useToggle()
  const { currentRegionCode } = useContext(GeoContext)

  const contactOrVisitTitle = intl.formatMessage({
    id: 'b22MFRDZjlNBiR6HNsYh',
    defaultMessage: 'Contact or visit us',
    description:
      'Summary row title for the expandable contact section in the navigation hamburger menu, shown before detailed support options.',
  })
  const contactUsOnlyTitle = intl.formatMessage({
    id: '40bVsRMvxubQsEdLc7Cw',
    defaultMessage: 'Contact us',
    description: 'Contact us button text for tablet and below in the support area',
  })
  const summaryTitle = shouldRenderTimely(currentRegionCode) ? contactOrVisitTitle : contactUsOnlyTitle

  const summarySubtitle = intl.formatMessage({
    id: 'VJsd-xJLC1JE0iwO2pfO',
    defaultMessage: 'Luxury Escapes support',
    description:
      'Summary row subtitle under the contact heading in the navigation hamburger menu, indicating support is from Luxury Escapes.',
  })

  return (
    <Group direction="vertical" gap={8}>
      <NavBarListItem
        onClick={toggleExpanded}
        title={summaryTitle}
        subtitle={summarySubtitle}
        startIcon={<NavBarListItemIcon Icon={LinePhoneIcon} />}
        endIcon={expanded
          ? <LineAngleUpIcon size="S" />
          : <LineAngleDownIcon size="S" />}
      />
      <Expander expanded={expanded}>
        <NavBarContactsItems onItemClick={onItemClick} />
      </Expander>
    </Group>
  )
}

export default NavBarHamburgerMenuContactsAccordion
